import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useMainContext } from "../../../Context";

export const useDashboard = ({ api, key }) => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const { post } = useMainContext();
  useEffect(() => {
    getData();
  }, []);
  const getData = async () => {
    setLoading(true);
    const { data } = await post(api?.route);
    setData(data);
    setLoading(false);
  };

  return {
    loading,
    data,
  };
};
